export default [
  { path: '*', redirect: '/' },
  {
    path: '/',
    component: require('@/views/Status.vue').default
  }
];
